import { render, staticRenderFns } from "./AvatarUploadSelector.vue?vue&type=template&id=033bfd44&scoped=true"
import script from "./AvatarUploadSelector.vue?vue&type=script&lang=js"
export * from "./AvatarUploadSelector.vue?vue&type=script&lang=js"
import style0 from "./AvatarUploadSelector.vue?vue&type=style&index=0&id=033bfd44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033bfd44",
  null
  
)

export default component.exports